import { Dialog, DialogContent, DialogTitle, Stack, useTheme } from '@mui/material'
import { Typography } from 'ComponentLibrary/src/atoms/typography'
import { IconButton } from 'ComponentLibrary/src/atoms/Buttons/IconButton'
import { X } from 'react-feather'
import { FooterLocale, useFooterCopy } from 'ComponentLibrary/src/molecules/Footer/footerCopy'

type ImprintProps = {
    isImprintOpen: boolean
    setIsImprintOpen?: (open: boolean) => void
    locale?: FooterLocale
}

export const Imprint = ({ isImprintOpen, setIsImprintOpen, locale }: ImprintProps) => {
    const theme = useTheme()
    const copy = useFooterCopy(locale)
    return (
        <Dialog maxWidth="sm" open={isImprintOpen} onClose={() => setIsImprintOpen?.(false)}>
            <DialogTitle marginX={theme.spacing(8)} marginY={theme.spacing(4)}>
                <Stack direction="row" justifyContent="space-between" width="100%">
                    <Typography variant="headline1">{copy.imprintModal.title}</Typography>
                    {setIsImprintOpen && (
                        <IconButton icon={<X color={theme.palette.customtext.black54} />} onClick={() => setIsImprintOpen(false)} />
                    )}
                </Stack>
            </DialogTitle>
            <DialogContent sx={{ borderTop: `1px solid ${theme.palette.secondary1.grey}`, color: theme.palette.customtext.black100 }}>
                <Stack direction="column" gap={theme.spacing(8)} margin={theme.spacing(8)}>
                    <Stack direction="column" gap={theme.spacing(1)}>
                        <Typography variant="captionMedium">{copy.imprintModal.company}</Typography>
                        <Typography variant="bodyTextMedium">{copy.imprintModal.street}</Typography>
                        <Typography variant="bodyTextMedium">{copy.imprintModal.city}</Typography>
                        <Typography variant="bodyTextMedium" style={{ marginTop: theme.spacing(2) }}>
                            {copy.imprintModal.email}
                        </Typography>
                    </Stack>
                    <Stack direction="column" gap={theme.spacing(1)}>
                        <Typography variant="captionMedium">{copy.imprintModal.representedByLabel}</Typography>
                        <Typography variant="bodyTextMedium">{copy.imprintModal.representedBy}</Typography>
                    </Stack>
                    <Stack direction="column" gap={theme.spacing(1)}>
                        <Typography variant="captionMedium">{copy.imprintModal.commercialRegisterLabel}</Typography>
                        <Typography variant="bodyTextMedium">{copy.imprintModal.commercialRegister}</Typography>
                    </Stack>
                    <Stack direction="column" gap={theme.spacing(1)}>
                        <Typography variant="captionMedium">{copy.imprintModal.vatIdLabel}</Typography>
                        <Typography variant="bodyTextMedium">{copy.imprintModal.vatId}</Typography>
                        <Typography variant="bodyTextMedium" style={{ marginTop: theme.spacing(2) }}>
                            {copy.imprintModal.disputeResolutionPrefix}
                            <a target="_blank" href="https://ec.europa.eu/consumers/odr/" rel="noreferrer">
                                https://ec.europa.eu/consumers/odr/
                            </a>
                            {copy.imprintModal.disputeResolutionSuffix}
                        </Typography>
                    </Stack>
                    <Stack direction="column" gap={theme.spacing(1)}>
                        <Typography variant="captionMedium">{copy.imprintModal.liabilityForContentsTitle}</Typography>
                        <Typography variant="bodyTextMedium">{copy.imprintModal.liabilityForContentsBody}</Typography>
                    </Stack>
                    <Stack direction="column" gap={theme.spacing(1)}>
                        <Typography variant="captionMedium">{copy.imprintModal.liabilityForLinksTitle}</Typography>
                        <Typography variant="bodyTextMedium">{copy.imprintModal.liabilityForLinksBody}</Typography>
                    </Stack>
                    <Stack direction="column" gap={theme.spacing(1)}>
                        <Typography variant="captionMedium">{copy.imprintModal.copyrightTitle}</Typography>
                        <Typography variant="bodyTextMedium">{copy.imprintModal.copyrightBody}</Typography>
                    </Stack>
                    <Stack direction="column" gap={theme.spacing(1)}>
                        <Typography variant="captionMedium">{copy.imprintModal.termsTitle}</Typography>
                        <Typography variant="bodyTextMedium">{copy.imprintModal.termsBody}</Typography>
                    </Stack>
                    <Stack direction="column" gap={theme.spacing(1)}>
                        <Typography variant="captionMedium">{copy.imprintModal.openSourceTitle}</Typography>
                        <Typography variant="bodyTextMedium">
                            {copy.imprintModal.openSourcePrefix}
                            <a target="_blank" href="/open-source-notices.txt" rel="noreferrer">
                                /open-source-notices.txt
                            </a>
                            {copy.imprintModal.openSourceSuffix}
                        </Typography>
                    </Stack>
                </Stack>
            </DialogContent>
        </Dialog>
    )
}
